import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import {Skeleton} from '@mui/material';
import React from 'react';

const useStyles = makeStyles(theme => ({
  items__wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },

  items__table: {
    display: 'flex',
    flexDirection: 'column',

    '@media (max-width: 768px)': {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
    },
  },

  items__header: {
    display: 'none',
    gap: 12,
    padding: '0 8px',
    fontSize: 12,
    fontWeight: 600,
    color: '#777',

    '@media (max-width: 768px)': {
      display: 'table-row',
      backgroundColor: '#f5f5f5',
    },
  },

  items__headerCell: {
    '@media (max-width: 768px)': {
      display: 'table-cell',
      padding: 8,
    },
  },

  items__row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 8,
    borderRadius: 8,
    backgroundColor: '#fff',
    boxShadow: '0px 4px 8px rgba(0,0,0,0.05)',
    border: '1px solid transparent',
    transition: `
    box-shadow 0.25s ease,
    transform 0.25s ease,
    border-color 0.25s ease
  `,

    '@media (any-hover: hover)': {
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0px 8px 20px rgba(0,0,0,0.12)',
        borderColor: 'rgba(0, 0, 0, 0.08)',
      },
    },

    '@media (max-width: 768px)': {
      display: 'table-row',
      boxShadow: 'none',
      border: 'none',
      transform: 'none',
    },
  },

  items__cell: {
    fontSize: 13,
    whiteSpace: 'nowrap',

    '@media (max-width: 768px)': {
      display: 'table-cell',
      padding: 8,
      fontSize: 12,
      verticalAlign: 'middle',
    },
  },

  items__cellName: {
    flex: 1,
    whiteSpace: 'normal',

    '@media (max-width: 768px)': {
      maxWidth: 160,
    },
  },

  items__image: {
    width: 40,
    height: 40,
    objectFit: 'cover',
  },
}));

const ItemsTable = props => {
  const {items} = props;
  const classes = useStyles();

  return (
    <div
      style={{
        display: items?.length > 0 ? 'flex' : 'hidden',
        marginBottom: 24,
        flexDirection: 'column',
        gap: 12,
        width: 'full',
      }}>
      <h6>Замовленний товар:</h6>
      <div className={classes.items__wrapper}>
        <div className={classes.items__table}>
          <div className={classes.items__header}>
            {['Фото', 'Бренд', 'Артикул', 'Назва', 'SKU', 'Кількість'].map(
              title => (
                <span key={title} className={classes.items__headerCell}>
                  {title}
                </span>
              ),
            )}
          </div>

          {items?.map((item, index) => (
            <Link
              key={index}
              to={`/product/${item?.brand}/${item?.article}`}
              className={classes.items__row}>
              <div className={classes.items__cell}>
                {item?.image ? (
                  <img
                    src={item.image}
                    alt=""
                    className={classes.items__image}
                  />
                ) : (
                  <Skeleton variant="rectangular" width={40} height={40} />
                )}
              </div>

              <div className={classes.items__cell}>{item?.brand}</div>
              <div className={classes.items__cell}>{item?.article}</div>
              <div
                className={`${classes.items__cell} ${classes.items__cellName}`}>
                {item?.name}
              </div>
              <div className={classes.items__cell}>{item?.sku}</div>
              <div className={classes.items__cell}>
                {item?.quantity && `${item.quantity} шт.`}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ItemsTable;
